import React from "react";

function Calender() {
  return (
    <svg
      width="20"
      height="23"
      viewBox="0 0 20 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.0725 7.61523H0.85376C0.552979 7.61523 0.338135 7.40039 0.338135 7.09961V5.55273C0.338135 4.43555 1.24048 3.49023 2.40063 3.49023H4.46313V1.25586C4.46313 0.998047 4.67798 0.740234 4.97876 0.740234H6.69751C6.95532 0.740234 7.21313 0.998047 7.21313 1.25586V3.49023H12.7131V1.25586C12.7131 0.998047 12.928 0.740234 13.2288 0.740234H14.9475C15.2053 0.740234 15.4631 0.998047 15.4631 1.25586V3.49023H17.5256C18.6428 3.49023 19.5881 4.43555 19.5881 5.55273V7.09961C19.5881 7.40039 19.3303 7.61523 19.0725 7.61523ZM0.85376 8.99023H19.0725C19.3303 8.99023 19.5881 9.24805 19.5881 9.50586V20.6777C19.5881 21.8379 18.6428 22.7402 17.5256 22.7402H2.40063C1.24048 22.7402 0.338135 21.8379 0.338135 20.6777V9.50586C0.338135 9.24805 0.552979 8.99023 0.85376 8.99023ZM15.1624 13.1152L13.9592 11.9121C13.7444 11.6973 13.4006 11.6973 13.2288 11.9121L8.67407 16.4238L6.69751 14.4473C6.48267 14.2324 6.13892 14.2324 5.96704 14.4473L4.72095 15.6504C4.54907 15.8652 4.54907 16.166 4.72095 16.3809L8.28735 19.9473C8.45923 20.1621 8.80298 20.1621 9.01782 19.9473L15.1624 13.8457C15.3342 13.6738 15.3342 13.3301 15.1624 13.1152Z"
        fill="#0A0624"
      />
    </svg>
  );
}

export default Calender;
